import { axisColor, tickLabelFontSize, axisLabelFontSize, fontFamily } from './constants'

const label = {
  textAnchor: 'middle',
  fontFamily,
  fill: axisColor
}

export const axisLabel = {
  ...label,
  fontSize: axisLabelFontSize
}

export const tickLabelX = {
  ...label,
  fontSize: tickLabelFontSize
}

export const tickLabelY = {
  ...label,
  dx: '-0.25em',
  dy: '0.25em',
  textAnchor: 'end',
  fontSize: tickLabelFontSize
}
